const routers = [
    {
        path: '/',
        name: "首页",
        component: () => import("@/components/HomePage"),
    },
    {
        path: '/Login',
        name: "登录页",
        component: () => import("@/components/Login"),
    },
    {
        path: '/OrderList',
        name: "订单列表",
        component: () => import("@/components/OrderList"),
    },
    {
        path: '/CompleteOrder',
        name: "完成订单",
        component: () => import("@/components/CompleteOrder"),
    },
    {
        path: '/OrderManage',
        name: "订单管理",
        component: () => import("@/components/OrderManage"),
    },
    {
        path: '/SettlementList',
        name: "结算管理",
        component: () => import("@/views/settlement"),
    },
    {
        path: '/payment-records',
        name: "支付记录",
        component: () => import("@/views/settlement/payment-records"),
    },
    {
        path: '/deduction-records',
        name: "抵扣记录",
        component: () => import("@/views/settlement/deduction-records"),
    },
    {
        path: '/merge-pay-records',
        name: "合并支付记录",
        component: () => import("@/views/settlement/merge-pay-records"),
    },
    {
        path: '/retention-money',
        name: "质保金",
        component: () => import("@/views/manage/retention-money"),
    },
    {
        path: '/settlement/install',
        name: "安装费用",
        component: () => import("@/views/settlement/detail/install-page"),
    },
    {
        path: '/settlement/motivate',
        name: "激励费用",
        component: () => import("@/views/settlement/detail/motivate"),
    },
    {
        path: '/settlement/relatedOrder',
        name: "关联订单",
        component: () => import("@/views/settlement/detail/related-order"),
    },
    {
        path: '/settlement/fileList',
        name: "附件列表",
        component: () => import("@/views/settlement/detail/file-list"),
    },
    {
        path: '/settlement/material',
        name: "物料费用",
        component: () => import("@/views/settlement/detail/material"),
    },
    {
        path: '/settlement/manage',
        name: "管理费用",
        component: () => import("@/views/settlement/detail/manage"),
    },
    {
        path: '/settlement/other',
        name: "其他费用",
        component: () => import("@/views/settlement/detail/other"),
    },
    {
        path: '/settlement/commission',
        name: "增项提成",
        component: () => import("@/views/settlement/detail/commission-page"),
    },
    {
        path: '/DeviceManage',
        name: "充电桩管理",
        component: () => import("@/components/DeviceManage"),
    },
    {
        path: '/MyDevice',
        name: "我的充电桩",
        component: () => import("@/components/MyDevice"),
    },
    {
        path: '/QCode',
        name: "扫码测试",
        component: () => import("@/components/QCode"),
    },
    {
        path: '/SubHistory',
        name: "转借记录",
        component: () => import("@/components/SubHistory"),
    },
    {
        path: '/EntryList',
        name: "入职申请",
        component: () => import("@/components/Entry/Index"),
    },
    {
        path: '/EntryAdd',
        name: "新增申请",
        component: () => import("@/components/Entry/Add"),
    },
    {
        path: '/EntryAdd/Success',
        name: "提交成功",
        component: () => import("@/components/Entry/Success"),
    }
]

export default routers
